function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.471 2.438L4.744 7.166a.984.984 0 01-.273.808.989.989 0 01-.974.241.99.99 0 01-.975-.241.983.983 0 01-.273-.809L.522 5.438a.999.999 0 111.414-1.414l1.56 1.56 4.561-4.56a1 1 0 011.414 1.414z"
});

var SvgMark = function SvgMark(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTAgOSI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNDcxIDIuNDM4TDQuNzQ0IDcuMTY2YS45ODQuOTg0IDAgMCAxLS4yNzMuODA4Ljk4OS45ODkgMCAwIDEtLjk3NC4yNDEuOTkuOTkgMCAwIDEtLjk3NS0uMjQxLjk4My45ODMgMCAwIDEtLjI3My0uODA5TC41MjIgNS40MzhhLjk5OS45OTkgMCAxIDEgMS40MTQtMS40MTRsMS41NiAxLjU2IDQuNTYxLTQuNTZhMSAxIDAgMCAxIDEuNDE0IDEuNDE0eiIvPgo8L3N2Zz4K";
export { SvgMark as ReactComponent };